import PageModule from "@eisinc/Overrides/Pages/SavedOrderListPage";

export * from "@eisinc/Overrides/Pages/SavedOrderListPage";

export default PageModule;
